<div [ngClass]="{ 'dataview-wrapper': true, 'with-sidebar-bottom': bottomSidebarVisible }">
    <!-- -->
    <p-dataView *ngIf="isLoadingSkeleton" [value]="[1,2,3,4]" [paginator]="false" layout="grid">
        <!-- HEADER IDÊNTICO AO REAL -->
        <ng-template pTemplate="header">
            <div class="mb-2" style="display: flex; justify-content: space-between; width: 100%;">
                <div class="flex align-items-center">
                </div>
                <div class="flex align-items-center">
                </div>
            </div>

            <!-- Filter bar (skeleton view) -->
            <!-- Mesma estrutura do header real (.ss-l-header-row + .ss-l-select-all
                 vazio como placeholder) pra manter a posição do botão de filtro
                 idêntica entre o skeleton e o conteúdo real — sem isso ele "pulava"
                 de posição quando o skeleton dava lugar ao p-dataView real. -->
            <div class="ss-l-header-row flex flex-column md:flex-row md:justify-content-between gap-2">
                <div class="ss-l-filterbar">
                    <button pButton type="button" icon="pi pi-filter"
                        class="p-button-rounded border-none ss-l-filterbtn"></button>
                </div>
                <div class="ss-l-select-all"></div>
            </div>
        </ng-template>
        <!-- Skeleton gridItem -->
        <ng-template pTemplate="gridItem">
            <div class="col-12 sm:col-6 lg:col-4 xl:col-3 p-2 pt-3">
                <div class="m-3 border-1 surface-border video-upload-container flex relative">
                    <div class="aspect-ratio-container ss-l-video-container-inner" style="aspect-ratio: 9/16;">
                        <p-skeleton width="100%" height="250px" class="video-preview"></p-skeleton>
                    </div>
                    <!-- Optionally, mais skeletons para tags, botões, etc -->
                    <div style="position:absolute; bottom:10px; left:10px; right:10px;">
                        <p-skeleton width="70%" height="1rem"></p-skeleton>
                    </div>
                </div>
            </div>
        </ng-template>
    </p-dataView>
    <!-- -->

    <p-dataView *ngIf="!isLoadingSkeleton" #dv [value]="groupedAssets" [paginator]="true" [rows]="12" filterBy="name"
        (onPage)="scrollToTop()" [rowsPerPageOptions]="[12, 24, 96]" [sortField]="sortField" [sortOrder]="sortOrder"
        layout="grid">

        <ng-template pTemplate="header">
            <div class="mb-2" style="display: flex; justify-content: space-between; width: 100%;">
                <div class="flex align-items-center">
                </div>
                <div class="flex align-items-center">
                </div>
            </div>

            <!-- Filter bar + Selecionar todos -->
            <div class="ss-l-header-row flex flex-column md:flex-row md:justify-content-between gap-2">

                <!-- ===== Mobile: botão full-width "Filtros" + chips selecionados
                     empilhados abaixo (sem texto "Filtros" junto dos chips e sem
                     scroll horizontal) ===== -->
                <div *ngIf="isMobile" class="w-full">
                    <!-- Sem [label] (mesmo motivo do "Limpar filtros" do dialog: precisa
                         de dois textos de tamanhos diferentes na mesma linha) — ícone fixo
                         à esquerda + bloco de texto próprio, reaproveitando as classes
                         ss-l-clear-filters-* já usadas lá. A bolinha vermelha é um ::after
                         grudado no .p-button-icon via ss-l-has-badge. -->
                    <button pButton pRipple type="button" icon="pi pi-filter"
                        class="border-none w-full flex align-items-center justify-content-start gap-2 ss-l-filterbtn-mobile ss-l-clear-filters-btn"
                        [ngClass]="{'ss-l-has-badge': activeFiltersCount > 0}"
                        (click)="toggleFilterPanel()">
                        <span class="inline-flex align-items-baseline justify-content-center gap-1 ss-l-clear-filters-text">
                            <span class="font-semibold ss-l-clear-filters-label">Filtros</span>
                            <span *ngIf="activeFiltersCount > 0" class="text-xs white-space-nowrap">
                                ({{ filteredItemsCount }} itens)
                            </span>
                        </span>
                    </button>
                    <div *ngIf="activeFiltersCount > 0" class="ss-l-filter-chips-mobile flex flex-wrap gap-2 mt-2">
                        <p-chip *ngFor="let chip of selectedFilterChips; trackBy: trackFilterChip"
                            [label]="chip.label" [removable]="true" (onRemove)="removeFilterChip(chip)"
                            styleClass="ss-filter-chip"></p-chip>
                    </div>
                </div>

                <!-- ===== Desktop: pill que colapsa (só ícone) sem filtro ativo e
                     expande mostrando os chips quando há filtro(s) ===== -->
                <div *ngIf="!isMobile" class="ss-l-filterbar" [class.is-expanded]="activeFiltersCount > 0">
                    <div class="relative flex-shrink-0 ss-l-filterbtn-wrapper">
                        <button pButton type="button" icon="pi pi-filter"
                            class="p-button-rounded border-none flex align-items-center flex-shrink-0 ss-l-filterbtn"
                            [ngClass]="{'ss-l-has-badge': activeFiltersCount > 0}"
                            (click)="toggleFilterPanel()">
                            <span class="inline-flex align-items-baseline ml-2">
                                <span class="font-semibold white-space-nowrap">Filtros</span>
                                <span *ngIf="activeFiltersCount > 0" class="text-xs white-space-nowrap ml-1">
                                    ({{ filteredItemsCount }} itens)
                                </span>
                            </span>
                        </button>
                    </div>
                    <div class="ss-l-filter-content">
                        <span class="ss-l-filter-label font-bold text-base white-space-nowrap">
                            Filtros <span *ngIf="activeFiltersCount > 0">({{ activeFiltersCount }})</span>
                        </span>
                        <div class="ss-l-filter-chips">
                            <p-chip *ngFor="let chip of selectedFilterChips; trackBy: trackFilterChip"
                                [label]="chip.label" [removable]="true" (onRemove)="removeFilterChip(chip)"
                                styleClass="ss-filter-chip"></p-chip>
                        </div>
                    </div>
                </div>

                <div class="flex align-items-center ss-l-select-all">
                    <p-checkbox [(ngModel)]="selectAllOnPage" [binary]="true"
                        (onChange)="toggleSelectAllOnPage()" inputId="selectAllOnPage"
                        [disabled]="groupedAssets.length <= 1"></p-checkbox>
                    <label for="selectAllOnPage"
                        [ngClass]="groupedAssets.length <= 1 ? 'ss-l-select-all-label-disabled' : 'cursor-pointer'">Selecionar
                        todos</label>
                </div>
            </div>
        </ng-template>



        <ng-template let-item pTemplate="gridItem">
            <div *ngIf="isLoadingSkeleton; else contentTemplate">
                <div class="col-12 sm:col-6 lg:col-12 xl:col-2 p-2 pt-3" *ngFor="let _ of [].constructor(6)">
                    <div class="m-3 border-1 surface-border video-upload-container">
                        <div class="aspect-ratio-container ss-l-video-container-inner">
                            <p-skeleton width="100%" height="100%" class="video-preview"></p-skeleton>
                        </div>
                    </div>
                </div>
            </div>
            <ng-template #contentTemplate>
                <div class="col-12 sm:col-6 lg:col-4 xl:col-3 p-2 pt-3 topPage">

                    <div class="border-1 surface-border video-upload-container ss-card-with-bands flex flex-column relative ">
                        <!-- 🔲 Faixa superior real (fora da mídia): avatar + username (esquerda), pin + checkbox (direita) -->
                        <div class="ss-card-top-band flex align-items-center justify-content-between gap-2 flex-shrink-0">
                            <div class="flex align-items-center gap-2 min-w-0">
                                <!-- Avatar com ícone sobreposto -->
                                <div class="relative flex-shrink-0" style="width: 35px; height: 35px;">
                                    <img [src]="item.source_id?.toLowerCase() === 'up' ? avatarUrl : (item.insights?.insights?.profile_picture || '/assets/rosto.jpg')"
                                        width="35" height="35" class="border-circle" (error)="onImageError($event)" />

                                    <i *ngIf="item.source_id?.toLowerCase() === 'yt'"
                                        class="bi bi-youtube youtube-icon-badge"></i>
                                    <img [src]="getSourceIcon(item.source_id)" width="18" height="18"
                                        *ngIf="item.source_id?.toLowerCase() !== 'yt'"
                                        class="absolute bottom-0 right-0 border-circle source-icon"
                                        style="background: white; border: 1px solid #ccc; left: 22px; top: 20px;" />
                                </div>

                                <!-- Username e opcional loja -->
                                <div class="flex flex-column ml-1 min-w-0 flex-1">
                                    <div class="text-sm font-bold text-base white-space-nowrap overflow-hidden text-overflow-ellipsis">
                                        {{ item.source_id?.toLowerCase() === 'up' ? '@' +
                                        (storeDomain?.split('.')?.[0] || '') :
                                        '@' + (item.insights?.insights?.username || 'usuário') }}
                                    </div>
                                    <div class="text-xs text-600 font-bold white-space-nowrap overflow-hidden text-overflow-ellipsis">
                                        {{ item.source_id?.toLowerCase() === 'up' ? storeName :
                                        (item.insights?.insights?.name || 'nome da conta') }}
                                    </div>
                                </div>
                            </div>

                            <!-- Pin + checkbox de seleção -->
                            <div class="flex align-items-center gap-2 flex-shrink-0">
                                <i (click)="solicitarFixar.emit(item.content.uid)"
                                    [ngClass]="item.media?.pin ? 'bi bi-pin-angle-fill' : 'bi bi-pin-angle'"
                                    class="cursor-pointer"></i>
                                <p-checkbox [binary]="true" [ngModel]="isSelected2(item)"
                                    (onChange)="toggleSelection2(item)">
                                </p-checkbox>
                            </div>
                        </div>

                        <!-- 🔲 Mídia: só o item (vídeo/imagem) com status + tag + menu sobrepostos -->
                        <div class="ss-l-video-container-inner relative flex-shrink-0">
                            <ng-container *ngIf="item.children?.data?.length > 0; else singleMedia">
                                <swiper #swiperInstance [attr.data-uid]="item.content.uid" [navigation]="false"
                                    [spaceBetween]="8" [slidesPerView]="1"
                                    class="video-media-content cursor-pointer"
                                    (click)="editSlick(item.content.uid)">
                                    <!-- Slide do item pai -->
                                    <ng-template swiperSlide>
                                        <ng-container *ngIf="item.media.src || item.media.thumbnail; else noMedia">
                                            <ng-container *ngIf="item.media.src">
                                                <video [muted]="true" #videoPlayer [src]="item.media.src"
                                                    [poster]="item.media.thumbnail" muted playsinline webkit-playsinline
                                                    class="shadow-2 video-preview" style="cursor: pointer;"
                                                    (click)="playVideo(videoPlayer)" (mouseenter)="startVideo(videoPlayer)"
                                                    (mouseleave)="resetVideo(videoPlayer)"></video>
                                                <i class="pi pi-play text-900" style="position: absolute; top: 50%; left: 50%; transform: translate(-50%, -50%);
                                                font-size: 2rem; z-index: 4; pointer-events: none;"></i>
                                            </ng-container>
                                            <ng-container *ngIf="!item.media.src && item.media.thumbnail">
                                                <img [src]="item.media.thumbnail" class="shadow-2 video-preview"
                                                    loading="lazy" style="object-fit: cover; width: 100% !important;" />
                                            </ng-container>
                                        </ng-container>
                                        <ng-template #noMedia>
                                            <img src="assets/img.jpg" class="shadow-2 video-preview" loading="lazy"
                                                style="object-fit: cover; width: 100% !important;" />
                                        </ng-template>

                                        <!-- Gradiente (mais escuro no topo, some pra baixo) atrás do status/menu -->
                                        <div class="video-gradient-top"></div>

                                        <!-- Pill de status + tag de direitos de uso + menu de 3 pontos -->
                                        <div class="ss-media-top-actions flex align-items-center gap-1"
                                            (pointerdown)="$event.stopPropagation()" (click)="$event.stopPropagation()">
                                            <p-tag *ngIf="item.source_id !== 'up' && item.source_id !== 'tt' && item.source_id !== 'yt' && (item.usage_rights === 'waiting' || item.usage_rights === 'approved' || item.usage_rights === 'rejected')"
                                                [icon]="getIconUsageRights(item.usage_rights)"
                                                [severity]="getSeverityUsageRights(item.usage_rights)"
                                                [pTooltip]="getTranslatedUsageRights(item.usage_rights)" tooltipPosition="bottom" tooltipEvent="focus" tabindex="0"
                                                class="ss-l-icon ss-usage-rights-pill" [rounded]="true">
                                            </p-tag>
                                            <div *ngIf="hasStoreIntegration" class="relative">
                                                <button pButton pRipple type="button" icon="bi bi-bag" class="ss-menu-btn border-none"
                                                    style="color: #fff; background: rgba(0, 0, 0, 0.35);"
                                                    pTooltip="Adicionar produtos" tooltipPosition="bottom"
                                                    (click)="openProductSidebar(item); $event.stopPropagation();"></button>
                                                <span *ngIf="getProductCount(item) as count" class="ss-l-custom-badge">{{ count }}</span>
                                            </div>

                                            <div class="ss-status-pill-host">
                                                <button pButton pRipple type="button"
                                                    class="ss-status-pill p-button-rounded"
                                                    (pointerdown)="$event.stopPropagation()"
                                                    (click)="statusMenuParent.toggle($event); $event.stopPropagation()">
                                                    <i class="pi ss-status-pill-icon" [ngClass]="item.media.status === 1 ? 'pi-eye' : 'pi-eye-slash'"></i>
                                                    <div class="ss-status-pill-label">{{ item.media.status === 1 ? 'Publicado' : 'Não Publicado' }}</div>
                                                    <i class="pi pi-chevron-down ss-status-pill-chevron"></i>
                                                </button>
                                                <p-menu #statusMenuParent [popup]="true" appendTo="body"
                                                    [model]="getStatusMenuItems(item)" [ssClickOutsideMenu]="statusMenuParent"></p-menu>
                                            </div>

                                            <!-- ===== Capacitor ===== -->
                                            <ng-container *ngIf="isNative; else webBranchParent">
                                                <div class="menu-host">
                                                    <button pButton pRipple class="ss-menu-btn border-none" #menuTargetParent
                                                        style="color: #fff; background: rgba(0, 0, 0, 0.35);"
                                                        (click)="menuParent.toggle($event)">
                                                        <i class="bi bi-three-dots-vertical"></i>
                                                    </button>
                                                    <p-menu #menuParent [target]="menuTargetParent" appendTo="target"
                                                        [model]="getActionMenu(item.content.id, item.content.uid, item.content.title)"
                                                        [popup]="true" class="ss-g-custom-menu-right" [ssClickOutsideMenu]="menuParent">
                                                    </p-menu>
                                                </div>
                                            </ng-container>

                                            <!-- ===== Web ===== -->
                                            <ng-template #webBranchParent>
                                                <div class="menu-host">
                                                    <button pButton pRipple class="ss-menu-btn border-none"
                                                        style="color: #fff; background: rgba(0, 0, 0, 0.35);"
                                                        (click)="menuParent.toggle($event)">
                                                        <i class="bi bi-three-dots-vertical"></i>
                                                    </button>
                                                    <p-menu #menuParent appendTo="body"
                                                        [model]="getActionMenu(item.content.id, item.content.uid, item.content.title)"
                                                        [popup]="true" class="ss-g-custom-menu-right" [ssClickOutsideMenu]="menuParent">
                                                    </p-menu>
                                                </div>
                                            </ng-template>
                                        </div>

                                        <!-- Caption -->
                                        <div class="absolute bottom-0 left-0 w-full z-2">
                                            <div class="video-gradient-bottom"></div>
                                            <div class="caption-wrapper text-white absolute left-0 w-full px-2 py-1 font-bold text-base"
                                                style="bottom: 8px !important;">
                                                <div
                                                    style="-webkit-box-orient: vertical; -webkit-line-clamp: 2; display: -webkit-box; overflow: hidden; word-break: break-word;">
                                                    {{ item.caption }}
                                                </div>
                                                <div class="ss-tags-scroll" (pointerdown)="$event.stopPropagation()"
                                                    (click)="$event.stopPropagation()">
                                                    <p-tag value="+ Tags" styleClass="ss-slick-tag ss-slick-tag-add"
                                                        (click)="openIndividualTagsDialog(item)"></p-tag>
                                                    <p-tag *ngFor="let tag of getDisplayTags(item)" [value]="tag" styleClass="ss-slick-tag"></p-tag>
                                                </div>
                                            </div>
                                        </div>
                                    </ng-template>

                                    <!-- Slides dos filhos -->
                                    <ng-template swiperSlide *ngFor="let child of item.children.data">
                                        <ng-container *ngIf="child.media.src || child.media.thumbnail; else noChildMedia">
                                            <ng-container *ngIf="child.media.src">
                                                <video #videoPlayer [muted]="true" [src]="child.media.src"
                                                    [poster]="child.media.thumbnail" muted playsinline webkit-playsinline
                                                    class="shadow-2 video-preview" style="cursor: pointer;"
                                                    (click)="playVideo(videoPlayer)" (mouseenter)="startVideo(videoPlayer)"
                                                    (mouseleave)="resetVideo(videoPlayer)"></video>
                                                <i class="pi pi-play text-900" style="position: absolute; top: 50%; left: 50%; transform: translate(-50%, -50%);
                                                font-size: 2rem; z-index: 4; pointer-events: none;"></i>
                                            </ng-container>
                                            <ng-container *ngIf="!child.media.src && child.media.thumbnail">
                                                <img [src]="child.media.thumbnail" class="shadow-2 video-preview"
                                                    loading="lazy" style="object-fit: cover; width: 100% !important;" />
                                            </ng-container>

                                            <!-- Gradiente (mais escuro no topo, some pra baixo) atrás do status/menu -->
                                            <div class="video-gradient-top"></div>

                                            <!-- Pill de status + tag de direitos de uso + menu de 3 pontos -->
                                            <div class="ss-media-top-actions flex align-items-center gap-2"
                                                (pointerdown)="$event.stopPropagation()" (click)="$event.stopPropagation()">
                                                <p-tag *ngIf="item.source_id !== 'up' && item.source_id !== 'tt' && item.source_id !== 'yt' && (item.usage_rights === 'waiting' || item.usage_rights === 'approved' || item.usage_rights === 'rejected')"
                                                    [icon]="getIconUsageRights(item.usage_rights)"
                                                    [severity]="getSeverityUsageRights(item.usage_rights)"
                                                    [pTooltip]="getTranslatedUsageRights(item.usage_rights)" tooltipPosition="bottom" tooltipEvent="focus" tabindex="0"
                                                    class="ss-l-icon ss-usage-rights-pill" [rounded]="true">
                                                </p-tag>
                                                <div *ngIf="hasStoreIntegration" class="relative">
                                                    <button pButton pRipple type="button" icon="bi bi-bag" class="ss-menu-btn border-none"
                                                        style="color: #fff; background: rgba(0, 0, 0, 0.35);"
                                                        pTooltip="Adicionar produtos" tooltipPosition="bottom"
                                                        (click)="openProductSidebar(child); $event.stopPropagation();"></button>
                                                    <span *ngIf="getProductCount(child) as count" class="ss-l-custom-badge">{{ count }}</span>
                                                </div>
                                                <div class="ss-status-pill-host">
                                                    <button pButton pRipple type="button"
                                                        class="ss-status-pill p-button-rounded"
                                                        (pointerdown)="$event.stopPropagation()"
                                                        (click)="statusMenuChild.toggle($event); $event.stopPropagation()">
                                                        <i class="pi ss-status-pill-icon" [ngClass]="child.media.status === 1 ? 'pi-eye' : 'pi-eye-slash'"></i>
                                                        <div class="ss-status-pill-label">{{ child.media.status === 1 ? 'Publicado' : 'Não Publicado' }}</div>
                                                        <i class="pi pi-chevron-down ss-status-pill-chevron"></i>
                                                    </button>
                                                    <p-menu #statusMenuChild [popup]="true" appendTo="body"
                                                        [model]="getStatusMenuItems(child)" [ssClickOutsideMenu]="statusMenuChild"></p-menu>
                                                </div>

                                                <!-- ===== Capacitor ===== -->
                                                <ng-container *ngIf="isNative; else webBranchChild">
                                                    <div class="menu-host">
                                                        <button pButton pRipple class="ss-menu-btn border-none" #menuTargetChild
                                                            style="color: #fff; background: rgba(0, 0, 0, 0.35);"
                                                            (click)="menuChild.toggle($event)">
                                                            <i class="bi bi-three-dots-vertical"></i>
                                                        </button>
                                                        <p-menu #menuChild [target]="menuTargetChild" appendTo="target"
                                                            [model]="getActionMenu(item.content.id, item.content.uid, item.content.title)"
                                                            [popup]="true" class="ss-g-custom-menu-right" [ssClickOutsideMenu]="menuChild">
                                                        </p-menu>
                                                    </div>
                                                </ng-container>

                                                <!-- ===== Web ===== -->
                                                <ng-template #webBranchChild>
                                                    <div class="menu-host">
                                                        <button pButton pRipple class="ss-menu-btn border-none"
                                                            style="color: #fff; background: rgba(0, 0, 0, 0.35);"
                                                            (click)="menuChild.toggle($event)">
                                                            <i class="bi bi-three-dots-vertical"></i>
                                                        </button>
                                                        <p-menu #menuChild appendTo="body"
                                                            [model]="getActionMenu(item.content.id, item.content.uid, item.content.title)"
                                                            [popup]="true" class="ss-g-custom-menu-right" [ssClickOutsideMenu]="menuChild">
                                                        </p-menu>
                                                    </div>
                                                </ng-template>
                                            </div>

                                            <!-- Caption -->
                                            <div class="absolute bottom-0 left-0 w-full z-2">
                                                <div class="video-gradient-bottom"></div>
                                                <div class="caption-wrapper text-white absolute left-0 w-full px-2 py-1 font-bold text-base"
                                                    style="bottom: 8px !important;">
                                                    <div
                                                        style="-webkit-box-orient: vertical; -webkit-line-clamp: 2; display: -webkit-box; overflow: hidden; word-break: break-word;">
                                                        {{ item.caption || child?.caption }}
                                                    </div>
                                                    <div class="ss-tags-scroll" (pointerdown)="$event.stopPropagation()"
                                                        (click)="$event.stopPropagation()">
                                                        <p-tag value="+ Tags" styleClass="ss-slick-tag ss-slick-tag-add"
                                                            (click)="openIndividualTagsDialog(item)"></p-tag>
                                                        <p-tag *ngFor="let tag of getDisplayTags(item)" [value]="tag" styleClass="ss-slick-tag"></p-tag>
                                                    </div>
                                                </div>
                                            </div>
                                        </ng-container>
                                        <ng-template #noChildMedia>
                                            <img src="assets/img.jpg" class="shadow-2 video-preview" loading="lazy"
                                                style="object-fit: cover; width: 100% !important;" />
                                        </ng-template>
                                    </ng-template>
                                </swiper>
                                <div class="arrow-toggle-container left-arrow">
                                    <button class="circular-nav-button" pButton pRipple
                                        (click)="slideToPrev(item.content.uid)">
                                        <i class="pi pi-chevron-left video-nav-arrow"
                                            style="position: absolute; left: 19%;"></i>
                                    </button>
                                </div>

                                <div class="arrow-toggle-container right-arrow">
                                    <button class="circular-nav-button" pButton pRipple
                                        (click)="slideToNext(item.content.uid)">
                                        <i class="pi pi-chevron-right video-nav-arrow"
                                            style="position: absolute; right: 19%;"></i>
                                    </button>
                                </div>
                            </ng-container>

                            <!-- Caso não tenha filhos: fallback com mídia única -->
                            <ng-template #singleMedia>
                                <div class="video-media-content cursor-pointer" (click)="editSlick(item.content.uid)">
                                    <ng-container *ngIf="item.media.src || item.media.thumbnail; else noMediaSingle">
                                        <ng-container *ngIf="item.media.src">
                                            <video #videoPlayer [muted]="true" [src]="item.media.src"
                                                [poster]="item.media.thumbnail" muted playsinline webkit-playsinline
                                                class="shadow-2 video-preview absolute w-full h-full"
                                                style="object-fit: cover; cursor: pointer;"
                                                (click)="playVideo(videoPlayer)" (mouseenter)="startVideo(videoPlayer)"
                                                (mouseleave)="resetVideo(videoPlayer)"></video>
                                            <i class="pi pi-play text-900" style="position: absolute; top: 50%; left: 50%; transform: translate(-50%, -50%);
                                            font-size: 2rem; z-index: 4; pointer-events: none;"></i>
                                        </ng-container>
                                        <ng-container *ngIf="!item.media.src && item.media.thumbnail">
                                            <img [src]="item.media.thumbnail"
                                                class="shadow-2 video-preview absolute w-full h-full" loading="lazy"
                                                style="object-fit: cover;" />
                                        </ng-container>
                                    </ng-container>

                                    <ng-template #noMediaSingle>
                                        <img src="assets/img.jpg" class="shadow-2 video-preview absolute w-full h-full"
                                            loading="lazy" style="object-fit: cover;" />
                                    </ng-template>

                                    <!-- Gradiente (mais escuro no topo, some pra baixo) atrás do status/menu -->
                                    <div class="video-gradient-top"></div>

                                    <!-- Pill de status + tag de direitos de uso + menu de 3 pontos -->
                                    <div class="ss-media-top-actions flex align-items-center gap-1" (click)="$event.stopPropagation()">
                                        <p-tag *ngIf="item.source_id !== 'up' && item.source_id !== 'tt' && item.source_id !== 'yt' && (item.usage_rights === 'waiting' || item.usage_rights === 'approved' || item.usage_rights === 'rejected')"
                                            [icon]="getIconUsageRights(item.usage_rights)"
                                            [severity]="getSeverityUsageRights(item.usage_rights)"
                                            [pTooltip]="getTranslatedUsageRights(item.usage_rights)" tooltipPosition="bottom" tooltipEvent="focus" tabindex="0"
                                            class="ss-l-icon ss-usage-rights-pill" [rounded]="true">
                                        </p-tag>
                                        <div *ngIf="hasStoreIntegration" class="relative">
                                            <button pButton pRipple type="button" icon="bi bi-bag" class="ss-menu-btn border-none"
                                                style="color: #fff; background: rgba(0, 0, 0, 0.35);"
                                                pTooltip="Adicionar produtos" tooltipPosition="bottom"
                                                (click)="openProductSidebar(item); $event.stopPropagation();"></button>
                                            <span *ngIf="getProductCount(item) as count" class="ss-l-custom-badge">{{ count }}</span>
                                        </div>

                                        <div class="ss-status-pill-host">
                                            <button pButton pRipple type="button"
                                                class="ss-status-pill p-button-rounded"
                                                (click)="statusMenuSingle.toggle($event)">
                                                <i class="pi ss-status-pill-icon" [ngClass]="item.media.status === 1 ? 'pi-eye' : 'pi-eye-slash'"></i>
                                                <div class="ss-status-pill-label">{{ item.media.status === 1 ? 'Publicado' : 'Não Publicado' }}</div>
                                                <i class="pi pi-chevron-down ss-status-pill-chevron"></i>
                                            </button>
                                            <p-menu #statusMenuSingle [popup]="true" appendTo="body"
                                                [model]="getStatusMenuItems(item)" [ssClickOutsideMenu]="statusMenuSingle"></p-menu>
                                        </div>

                                        <!-- ===== Capacitor ===== -->
                                        <ng-container *ngIf="isNative; else webBranchSingle">
                                            <div class="menu-host">
                                                <button pButton pRipple class="ss-menu-btn border-none" #menuTargetSingle
                                                    style="color: #fff; background: rgba(0, 0, 0, 0.35);"
                                                    (click)="menuSingle.toggle($event)">
                                                    <i class="bi bi-three-dots-vertical"></i>
                                                </button>
                                                <p-menu #menuSingle [target]="menuTargetSingle" appendTo="target"
                                                    [model]="getActionMenu(item.content.id, item.content.uid, item.content.title)"
                                                    [popup]="true" class="ss-g-custom-menu-right" [ssClickOutsideMenu]="menuSingle">
                                                </p-menu>
                                            </div>
                                        </ng-container>

                                        <!-- ===== Web ===== -->
                                        <ng-template #webBranchSingle>
                                            <div class="menu-host">
                                                <button pButton pRipple class="ss-menu-btn border-none"
                                                    style="color: #fff; background: rgba(0, 0, 0, 0.35);"
                                                    (click)="menuSingle.toggle($event)">
                                                    <i class="bi bi-three-dots-vertical"></i>
                                                </button>
                                                <p-menu #menuSingle appendTo="body"
                                                    [model]="getActionMenu(item.content.id, item.content.uid, item.content.title)"
                                                    [popup]="true" class="ss-g-custom-menu-right" [ssClickOutsideMenu]="menuSingle">
                                                </p-menu>
                                            </div>
                                        </ng-template>
                                    </div>

                                    <!-- Caption -->
                                    <div class="absolute bottom-0 left-0 w-full z-2">
                                        <div class="video-gradient-bottom"></div>
                                        <div class="caption-wrapper text-white absolute left-0 w-full px-2 py-1 font-bold text-base"
                                            style="bottom: 8px !important;">
                                            <div
                                                style="-webkit-box-orient: vertical; -webkit-line-clamp: 2; display: -webkit-box; overflow: hidden; word-break: break-word;">
                                                {{ item.caption }}
                                            </div>
                                            <div class="ss-tags-scroll" (click)="$event.stopPropagation()">
                                                <p-tag value="+ Tags" styleClass="ss-slick-tag ss-slick-tag-add"
                                                    (click)="openIndividualTagsDialog(item)"></p-tag>
                                                <p-tag *ngFor="let tag of getDisplayTags(item)" [value]="tag" styleClass="ss-slick-tag"></p-tag>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </ng-template>
                        </div>

                        <!-- 🔲 Faixa inferior real (fora da mídia): tempo, comentários, curtidas -->
                        <div class="ss-item-footer flex align-items-center justify-content-around flex-shrink-0">
                            <div class="ss-item-footer-metric">
                                <i class="pi pi-clock"></i>
                                <span>{{ formatTimestamp(item.post_timestamp) }}</span>
                            </div>
                            <ng-container *ngIf="item.source_id?.toLowerCase() !== 'up'">
                                <div class="border-left-1 border-right-1 surface-border h-full"></div>
                                <div class="ss-item-footer-metric ">
                                    <i class="pi pi-comments"></i>
                                    <span>{{ item.insights?.comment_count || 0 }} comentários</span>
                                </div>
                                <div class="border-left-1 border-right-1 surface-border h-full"></div>
                                <div class="ss-item-footer-metric">
                                    <i class="pi pi-heart"></i>
                                    <span>{{ item.insights?.like_count || 0 }} curtidas</span>
                                </div>
                            </ng-container>
                        </div>

                    </div>
                </div>
            </ng-template>
        </ng-template>

        <ng-template pTemplate="empty">
            <div class="flex flex-column align-items-center justify-content-center py-6 text-center w-full">
                <i class="pi pi-images text-5xl text-primary mb-3" style="opacity: 0.6;"></i>
                <span class="text-xl font-semibold text-900 mb-2">Nenhum slick encontrado</span>
                <span class="text-sm text-400 font-light mb-3 px-4" style="max-width: 400px;">Importe vídeos e fotos das redes sociais ou faça upload para começar a criar conteúdo interativo.</span>
                <button pButton pRipple icon="pi pi-plus" class="p-button-rounded" (click)="addSlick.emit()"></button>
            </div>
        </ng-template>
    </p-dataView>
</div>
<p-sidebar [(visible)]="bottomSidebarVisible" position="bottom" [modal]="false"
    class="no-overlay-sidebar custom-sidebar" [showCloseIcon]="false" [baseZIndex]="10000" [dismissable]="false">



    <ng-template pTemplate="footer">
        <div
            class="flex flex-column sm:flex-row justify-content-between align-items-start sm:align-items-center w-full px-3 py-2 gap-3 overflow-hidden">
            <!-- 🔹 Lado esquerdo -->
            <div class="flex align-items-center gap-2">
                <span class="font-medium text-900 text-sm sm:text-base">
                    {{ selectedItems.length }} selecionado{{ selectedItems.length !== 1 ? 's' : '' }}
                </span>
                <a (click)="clearSelection()"
                    class="text-primary text-sm font-medium cursor-pointer flex align-items-center gap-1">
                    <i class="pi pi-times-circle text-primary text-sm"></i> Limpar seleção
                </a>
            </div>

            <!-- 🔹 Lado direito -->
            <div class="flex flex-column sm:flex-row gap-2 w-full sm:w-auto">
                <!-- <button pButton icon="pi pi-copyright" label="Solicitar direitos de uso"
                    [disabled]="!possuiItensInstagram" class="p-button-outlined w-full sm:w-auto"
                    (click)="abrirDialogDireitos()"></button> -->
                <button pButton icon="pi pi-tag" (click)="openBulkTagsDialog()" label="Adicionar tags"
                    class="p-button-outlined w-full sm:w-auto"></button>
                <button *ngIf="hasStoreIntegration" pButton icon="bi bi-bag" (click)="openBulkProductsDialog()" label="Produtos"
                    class="p-button-outlined w-full sm:w-auto"></button>
                <button pButton icon="pi pi-times" (click)="despublicarSelecionados()" label="Despublicar"
                    class="p-button-outlined p-button-danger w-full sm:w-auto"></button>
                <button pButton icon="pi pi-check" (click)="publicarSelecionados()" [loading]="loadPub" label="Publicar"
                    class="p-button-success w-full sm:w-auto"></button>
                <button pButton icon="pi pi-trash" (click)="confirmRemoveSelected()"
                    class="p-button-outlined p-button-secondary w-full sm:w-auto btn-delete-mobile"></button>
            </div>
        </div>
    </ng-template>
</p-sidebar>

<p-dialog [(visible)]="bulkTagsDialogVisible" [modal]="true" [closable]="true" [dismissableMask]="true"
    [draggable]="false" [resizable]="false" header="Adicionar tags" class="ss-g-dialog-sized"
    [style]="{width: '450px'}">
    <div class="flex flex-column w-full">
        <label class="ss-g-globalClassLabel mb-2">
            Adicionar aos {{ selectedItems.length }} slick{{ selectedItems.length !== 1 ? 's' : '' }} selecionado{{ selectedItems.length !== 1 ? 's' : '' }}
        </label>
        <p-chips [(ngModel)]="bulkTagsInput" class="w-full" separator=","
            placeholder="Insira uma tag e aperte ',' ou ⏎" styleClass="w-full"></p-chips>
    </div>

    <ng-template pTemplate="footer">
        <button pButton label="Cancelar" class="p-button-outlined" (click)="bulkTagsDialogVisible = false"></button>
        <button pButton label="Aplicar" [icon]="loadingBulkTags ? 'pi pi-spin pi-spinner' : 'pi pi-check'"
            [disabled]="!bulkTagsInput.length || loadingBulkTags" (click)="applyBulkTags()"></button>
    </ng-template>
</p-dialog>

<p-dialog [(visible)]="individualTagsDialogVisible" [modal]="true" [closable]="true" [dismissableMask]="true"
    [draggable]="false" [resizable]="false" header="Tags do slick" class="ss-l-bulk-products-dialog"
    [style]="{width: '450px'}">
    <div class="flex flex-column w-full">
        <label class="ss-g-globalClassLabel mb-2">Adicione ou remova as tags deste slick</label>
        <p-chips [(ngModel)]="individualTagsInput" class="w-full" separator="," styleClass="w-full"
            placeholder="Insira uma tag e aperte ',' ou ⏎"></p-chips>
    </div>

    <ng-template pTemplate="footer">
        <button pButton label="Cancelar" class="p-button-outlined" (click)="individualTagsDialogVisible = false"></button>
        <button pButton label="Salvar" [icon]="loadingIndividualTags ? 'pi pi-spin pi-spinner' : 'pi pi-check'"
            [disabled]="loadingIndividualTags" (click)="applyIndividualTags()"></button>
    </ng-template>
</p-dialog>

<p-dialog [(visible)]="bulkProductsDialogVisible" [modal]="true" [closable]="true" [dismissableMask]="true"
    [draggable]="false" [resizable]="false" header="Adicionar produtos" class="ss-l-bulk-products-dialog"
    [style]="{width: '450px'}">
    <div class="flex flex-column w-full">
        <label class="ss-g-globalClassLabel mb-2">
            Adicionar aos {{ selectedItems.length }} slick{{ selectedItems.length !== 1 ? 's' : '' }} selecionado{{ selectedItems.length !== 1 ? 's' : '' }}
        </label>
        <small class="text-500 mb-2">Produtos já associados a um slick não são duplicados.</small>
        <p-multiSelect [options]="bulkProductsOptions" [(ngModel)]="bulkProductsSelected" optionLabel="label"
            optionValue="value" display="chip" placeholder="Selecione os produtos" class="w-full"
            [style]="{width: '100%'}" [filter]="true" filterBy="label" [loading]="loadingBulkProductsCatalog"
            appendTo="body">
            <ng-template let-option pTemplate="item">
                <div class="flex align-items-center gap-2">
                    <img [src]="option.value.thumbnail" class="w-2rem h-2rem border-round" style="object-fit: cover;" />
                    <span>{{ option.label }}</span>
                </div>
            </ng-template>
        </p-multiSelect>
    </div>

    <ng-template pTemplate="footer">
        <button pButton label="Cancelar" class="p-button-outlined" (click)="bulkProductsDialogVisible = false"></button>
        <button pButton label="Aplicar" [icon]="loadingBulkProducts ? 'pi pi-spin pi-spinner' : 'pi pi-check'"
            [disabled]="!bulkProductsSelected.length || loadingBulkProducts" (click)="applyBulkProducts()"></button>
    </ng-template>
</p-dialog>

<p-dialog [(visible)]="dialogDireitosVisivel" [modal]="true" [closable]="true" [dismissableMask]="true"
    class="dialog1 ss-g-dialog-sized" header="Solicitar direitos autorais" (onShow)="onDireitosDialogShow()">

    <app-usage-rights #usageRightsRef
        [items]="itensParaDireitosDialog"
        mode="dialog"
        (saved)="onDireitosSaved($event)"
        (commentSent)="onDireitosCommentSent($event)">
    </app-usage-rights>

    <ng-template pTemplate="footer">
        <button pButton type="button" label="Fechar" (click)="dialogDireitosVisivel = false"
            class="p-button-outlined text-primary border-primary"></button>
    </ng-template>
</p-dialog>
<!-- Filter dialog -->
<p-dialog [(visible)]="filterPanelOpen" [modal]="true" [closable]="true" [dismissableMask]="true"
    [draggable]="false" [resizable]="false" styleClass="ss-l-filter-dialog ss-g-dialog-sized" (onHide)="closeFilterPanel()">
    <ng-template pTemplate="header">
        <div class="flex align-items-center gap-2 w-full">
            <i class="pi pi-filter text-primary"></i>
            <span class="font-bold text-lg white-space-nowrap">
                Filtros <span *ngIf="activeFiltersCount > 0">({{ activeFiltersCount }})</span>
            </span>
            <div class="ss-l-dialog-chips">
                <p-chip *ngFor="let chip of selectedFilterChips; trackBy: trackFilterChip"
                    [label]="chip.label" [removable]="true" (onRemove)="removeFilterChip(chip)"
                    styleClass="ss-filter-chip"></p-chip>
            </div>
        </div>
    </ng-template>

    <div class="flex flex-column gap-3">
        <p-calendar [(ngModel)]="rangeDates" class="w-full" selectionMode="range" placeholder="Período"
            [readonlyInput]="true" [showIcon]="true" (ngModelChange)="handleDateChange($event)" appendTo="body">
        </p-calendar>

        <p-dropdown placeholder="Status do Slick" [options]="statusOptions" [(ngModel)]="selectedStatus"
            class="w-full" (onChange)="handleStatusChange($event)" [showClear]="true" appendTo="body">
            <ng-template let-option pTemplate="item">
                <p-tag [value]="option.label" [severity]="getSeverityStatusDropdown(option.value)"></p-tag>
            </ng-template>
        </p-dropdown>

        <span class="p-input-icon-left w-full">
            <i class="pi pi-search"></i>
            <input type="search" [(ngModel)]="searchTerm" pInputText class="w-full"
                placeholder="Buscar por nome" (input)="onFilterSlicks.emit($event)">
        </span>

        <p-multiSelect [options]="mediaTypeOptions" [(ngModel)]="selectedMediaTypes"
            (onChange)="handleMediaTypeChange($event)" placeholder="Tipo de Mídia" class="w-full"
            display="chip" optionLabel="label" optionValue="value" appendTo="body">
            <ng-template let-option pTemplate="item">
                <p-chip [label]="option.label"
                    [styleClass]="'p-chip-rounded p-chip-' + getMediaTypeSeverity(option.value)"></p-chip>
            </ng-template>
        </p-multiSelect>

        <p-multiSelect [options]="sourceOptions" [(ngModel)]="selectedSources"
            (onChange)="handleSourceChange($event)" placeholder="Fonte"
            class="w-full ss-l-multFilter" display="chip" optionLabel="label" optionValue="value" appendTo="body">
            <ng-template let-option pTemplate="item">
                <p-chip [label]="option.label" [image]="getSourceIcon(option.value)"
                    [styleClass]="'p-chip-rounded p-chip-' + getSourceSeverity(option.value)" class="mr-1"></p-chip>
            </ng-template>
        </p-multiSelect>

        <p-multiSelect [options]="usageRightsOptions" [(ngModel)]="selectedUsageRights"
            (onChange)="handleUsageRightsChange($event)" placeholder="Direitos autorais"
            class="w-full" display="chip" optionLabel="label" optionValue="value" appendTo="body">
            <ng-template let-option pTemplate="item">
                <p-tag [value]="option.label" [severity]="getSeverityUsageRights(option.value)"
                    icon="bi bi-c-circle" [rounded]="true"></p-tag>
            </ng-template>
        </p-multiSelect>

        <p-multiSelect [options]="feedOptions" [(ngModel)]="selectedFeeds"
            (onChange)="handleFeedChange($event)" placeholder="Feed"
            class="w-full ss-l-multFilter ss-l-multFilter-feed" display="chip"
            optionLabel="username" optionValue="value" appendTo="body">
            <ng-template let-option pTemplate="item">
                <div class="flex align-items-center gap-2">
                    <img [src]="option.picture" width="18" height="18" class="border-circle" />
                    <span class="text-sm text-900">{{ option.username }}</span>
                    <p-chip *ngIf="option.feed_type" [label]="
                        getUnicodeIcon(option.feed_type) + ' ' + (
                        option.feed_type === 'hashtag' && option.hashtag_name ? '#' + option.hashtag_name :
                        option.feed_type === 'playlist' && option.playlist_title ? option.playlist_title :
                        option.feed_type)" styleClass="small-chip p-chip-rounded p-chip-info"></p-chip>
                </div>
            </ng-template>
        </p-multiSelect>

        <p-multiSelect [options]="tagOptions" [(ngModel)]="selectedTags"
            (onChange)="handleTagsChange($event)" placeholder="Tags"
            class="w-full" display="chip" optionLabel="label" optionValue="value" appendTo="body">
        </p-multiSelect>

        <p-multiSelect [options]="productOptions" [(ngModel)]="selectedProducts"
            (onChange)="handleProductsChange($event)" placeholder="Produtos"
            class="w-full" display="chip" optionLabel="label" optionValue="value" appendTo="body">
            <ng-template let-option pTemplate="item">
                <div class="flex align-items-center gap-2">
                    <img [src]="option.thumbnail" class="w-2rem h-2rem border-round" style="object-fit: cover;" />
                    <span>{{ option.label }}</span>
                </div>
            </ng-template>
        </p-multiSelect>
    </div>

    <ng-template pTemplate="footer">
        <button pButton label="Fechar" icon="pi pi-times" class="w-full" (click)="filterPanelOpen = false"></button>
        <button pButton icon="pi pi-filter-slash"
            class="p-button-outlined w-full mt-2 flex align-items-center justify-content-start gap-2 ss-l-clear-filters-btn"
            (click)="searchTerm = ''; clearFilter.emit(); filterPanelOpen = false;">
            <span class="inline-flex align-items-baseline justify-content-center gap-1 ss-l-clear-filters-text">
                <span class="font-semibold ss-l-clear-filters-label">Limpar filtros</span>
                <span *ngIf="activeFiltersCount > 0" class="text-xs white-space-nowrap">
                    ({{ filteredItemsCount }} itens)
                </span>
            </span>
        </button>
    </ng-template>
</p-dialog>

<p-sidebar [(visible)]="productSidebarVisible" position="right" class="ss-g-custom-sidebar-width"
    (onHide)="closeProductSidebar()">
    <ng-template pTemplate="header">
        <h4 class="mb-0">Produtos</h4>
    </ng-template>

    <ng-container *ngIf="!productSidebarLoading; else productSidebarLoadingTpl">
        <app-product-picklist [target]="productSidebarTarget" [isMobile]="isMobile" [itemTemplate]="productSidebarItemTpl"
            (moveToTarget)="onProductSidebarChanged()" (moveToSource)="onProductSidebarChanged()"></app-product-picklist>
    </ng-container>
    <ng-template #productSidebarLoadingTpl>
        <div class="flex flex-column gap-2 p-2">
            <p-skeleton width="100%" height="4rem"></p-skeleton>
            <p-skeleton width="100%" height="4rem"></p-skeleton>
            <p-skeleton width="100%" height="4rem"></p-skeleton>
        </div>
    </ng-template>

    <ng-template #productSidebarItemTpl let-product>
        <div class="flex flex-column p-2 gap-2 z-2" [class.clickable]="product.isSelected">
            <div class="flex align-items-center gap-2">
                <img class="w-4rem h-4rem shadow-2 border-round" style="object-fit: cover;" [src]="product.thumbnail" />
                <div class="flex-grow-1 flex flex-column">
                    <div class="font-bold">{{ product.name }}</div>
                    <div class="text-xs text-bluegray-500">{{ product.price | currency:'BRL':'symbol' }}</div>
                </div>
            </div>
        </div>
    </ng-template>

    <ng-template pTemplate="footer">
        <div class="w-full text-right p-0">
            <button pButton pRipple label="Fechar" (click)="closeProductSidebar()" class="p-button-outlined"></button>
        </div>
    </ng-template>
</p-sidebar>

<app-dialog-aguarde [visible]="displayAguarde"></app-dialog-aguarde>
<app-upgrade-dialog [(visible)]="showUpgradeDialog" [title]="upgradeDialogTitle" [message]="upgradeDialogMessage"
    [showActions]="upgradeDialogShowActions" (close)="showUpgradeDialog = false" (upgrade)="irParaAssinatura()">
</app-upgrade-dialog>
<!-- <p-dialog header="Confirmação" [(visible)]="displayConfirmDialog" [modal]="true" [closable]="false" [resizable]="false">
    <p>Marcando esta opção, este slick se tornará o primeiro vídeo do seu Link na Bio. Deseja Continuar?</p>
    <p-footer>
        <button type="button" pButton pRipple label="Sim" (click)="confirmFixarVideo()"></button>
        <button type="button" pButton pRipple label="Não" (click)="displayConfirmDialog = false"></button>
    </p-footer>
</p-dialog> -->